import CXMApiClient from "../CXMApiClient";
function initialState() {
  return {
    teamManagementInfo: [],
    paginationInfoForTeam: {
      pageNumber: 1,
      pageSize: 25,
      pageTotal: 0,
      totalRecords: 0
    }
  };
}

const state = initialState();

const actions = {
  getTeamManagementDataByFilters: function(context, request) {
    return new Promise(async (resolve, reject) => {
      let client = new CXMApiClient();
      let filter;
      filter = request.Filter;
      filter.pagination = request.Pagination;
      resolve(
        client
          .ProcessRequest(
            "post",
            "/api/Lead/lead/search",
            filter,
            request.scope
          )
          .then(response => {
            context.commit("udpateTeamManagementData", response.data.data);
            context.commit(
              "updatePaginationInfoForTeamMembers",
              response.data.pageData
            );
          })
          .catch(function(error) {
            reject(error);
          })
      );
    });
  },
  getTeamManagementDataForPrint: function(context, request) {
    return new Promise(async (resolve, reject) => {
      let client = new CXMApiClient();
      let filter;
      filter = request.Filter;
      filter.pagination = request.Pagination;
      resolve(
        client
          .ProcessRequest(
            "post",
            "/api/Lead/lead/search",
            filter,
            request.scope
          )
          .then(response => {
            return response.data.data;
          })
          .catch(function(error) {
            reject(error);
          })
      );
    });
  },
  getTeamManagementDataMobile(context, filter) {
    return new Promise(async (resolve, reject) => {
      let client = new CXMApiClient();
      resolve(
        client
          .ProcessRequest("post", "/api/Team/team/filtered/paged", filter)
          .then(response => {
            return response.data;
          })
          .catch(function(error) {
            reject(error);
          })
      );
    });
  }
};

const mutations = {
  udpateTeamManagementData: function(state, data) {
    state.teamManagementInfo = data;
  },
  updatePaginationInfoForTeamMembers: function(state, data) {
    state.paginationInfoForTeam = data;
  }
};

const getters = {
  teamManagementInfo: function() {
    return state.teamManagementInfo;
  },
  paginationInfoForTeam: function() {
    return state.paginationInfoForTeam;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/TeamManagement.js